import { Box, Container, Dialog, DialogContent, Divider, Grid, IconButton, Typography } from '@material-ui/core'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import {
    Add as AddIcon, BackspaceOutlined as BackspaceOutlinedIcon, Search as SearchIcon
} from '@material-ui/icons'
import EditIcon from '@material-ui/icons/Edit'
import MUIDataTable from "mui-datatables"
import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import SelectShedMovementType from '../../../components/Form/SelectShedMovementType'
import SelectUser from '../../../components/Form/SelectUser'
import Success from '../../../components/Form/Success'
import TextField from '../../../components/Form/TextField'
import BoxSlide from '../../../components/ui/BoxSlideUI'
import ButtonUI from '../../../components/ui/ButtonUI'
import LoadingUI from '../../../components/ui/LoadingUI'
import { useAuth } from '../../../hooks/auth'
import ShedApi from '../../../services/ShedApi'
import permissions from '../../../utils/Permissions'
import EditShedRegistrationForm from './EditShedRegistrationForm'
import RegistrationUserListForm from './RegistrationUserListForm'
import { DialogTitle, PaperComponent, useStyles } from './Style'

interface IFormInput {
    registration: any;
    userName: any;
    shed: any;
    movementType: any;
    responsibleUser: any;
}

const opcoes = [
    { url: '/ShedRegistration', descricao: 'Incluir', state: {openPanelOnLoad: true}},
    { url: '/ShedRegistration', descricao: 'Pesquisar', state: {}}
]

interface Params {
    openPanelOnLoad: boolean;
}

const ShedRegistration: React.FC = () => {
    const classes = useStyles()
    const history = useHistory();
    const { user, hasPermission } = useAuth();
    const location = useLocation<Params>();
    const [shedRegistrations, setShedRegistrations] = useState<any>([])
    const [loading, setLoading] = useState(true)
    const { t: tShed } = useTranslation("Shed")
    const { t: tGeneral } = useTranslation("General")
    const [count, setCount] = useState(0)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const refFieldRegistration = useRef<HTMLInputElement>(null)
    const [openedPainel, setOpenedPainel] = useState<boolean>(false)
    const [openedPainelList, setOpenedPainelList] = useState<boolean>(false)
    const [shedId, setShedId] = useState<any>(0)
    const [movementTypeId, setMovementTypeId] = useState<any>(0)
    const [movementTypeDescription, setMovementTypeDescription] = useState<any>(0)
    const [listVisualize, setListVisualize] = useState<any>([])
    const [success, setSuccess] = useState(false);

    const { handleSubmit, reset, control, getValues, setValue } = useForm<IFormInput>({
        defaultValues:{
            registration: '',
            userName: '',
            shed: {},
            movementType: {},
            responsibleUser: {}
        }
    })

    useEffect(() => {
        if (!hasPermission(permissions.SHED.UserManage))
            history.replace('NoPermission');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, user])

    useEffect(() => {
        search()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage, user])

    const search = async () => {

        setLoading(true)

        var data = getValues()

        var params = {
            registration: data.registration,
            userName: data.userName,
            shedId: data.shed && data.shed.code ? data.shed.code : '',
            movementTypeId: data.movementType && data.movementType.code ? data.movementType.code : '',
            responsibleUser: data.responsibleUser && data.responsibleUser.code ? data.responsibleUser.code : '',
            pageIndex: page,
            pageSize: rowsPerPage,
            plantId: user.company.plantID
        }

        ShedApi.searchregistrationManage(params)
        .then(response => {

            response.items.forEach((element: { shedCode: string; shedType: string }) => {
                element.shedCode = element.shedCode + ' - ' + (element.shedType === "D" ? tShed('unload') : tShed('load'))
            })

            setShedRegistrations(response.items)
            setCount(response.totalCount)
        })
        .finally(() => { setLoading(false)})
    }

    const options = {
        textLabels: {
            body: {
                noMatch: tGeneral('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: tGeneral("next"),
                previous: tGeneral("previous"),
                rowsPerPage: tGeneral("rowsPerPage") + ":",
                displayRows: tGeneral("of"),
            }
        }
    }

    const columns = [

        {
            name: 'shedId',
            options: {
                display: false,
            }
        },  
        {
            name: 'movementTypeId',
            options: {
                display: false,
            }
        },
        {
            name: 'shedType',
            options: {
                display: false,
            }
        },     
        {
            name: 'shedCode',
            label: tShed('shed'),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "left",
                    }),
                setCellProps: () => ({
                    align: "left"
                }),
            }
        },  
        {
            name: 'movementTypeDescription',
            label: tShed('movementType'),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'registrations',
            label: tShed('registrations'),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <p 
                            style={{ color: 'blue', cursor: 'pointer' }}
                            onClick={() => {
                                setListVisualize({
                                    title: tShed('registrations'),
                                    items: value.map((element: any) => ({ item: element.registrationUser + " - " + element.registrationUserName }))
                                })
                                setOpenedPainelList(true) }}>
                                    {tGeneral("totalRecords") + value.length}
                        </p>
                        
                    );
                }
            }
        }, 
        {
            name: 'users',
            label: tShed('responsibleUser'),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <p 
                            style={{ color: 'blue', cursor: 'pointer'  }}
                            onClick={() => { 
                                setListVisualize({
                                    title: tShed('responsibleUsers'),
                                    items: value.map((element: any) => ({ item: element.responsibleUser + " - " + element.responsibleUserName }))
                                }); 
                                setOpenedPainelList(true) }}>
                                    {tGeneral("totalRecords") + value.length}
                        </p>
                    );
                }
            }
        },  
        {
            name: '',
            label: '',
            options: {
                sort: false,
                setCellProps: () => ({
                    align: "right"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <Box  style={{ padding: "0px", textAlign: 'right' }}>
                            <IconButton aria-label="Edit" color="primary" onClick={() => editElement(tableMeta.rowData[0], tableMeta.rowData[1], tableMeta.rowData[4])}>
                                <EditIcon fontSize='small'/>                              
                            </IconButton>
                        </Box>

                    );
                }
            }
        }
    ]

    const editElement = (shedId: any, movementTypeId: any, movementTypeDescription: any) => {
        
        setShedId(shedId)
        setMovementTypeId(movementTypeId)
        setMovementTypeDescription(movementTypeDescription)
        setOpenedPainel(true)
    }   
    
    const defaultGridTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            }
        }
    })  

    const onSubmit = async (data: any) => {}    

    useEffect(() => {
        if (location.state?.openPanelOnLoad)
        {
            setShedId(0); 
            setOpenedPainel(true);
        }
    }, [location.state?.openPanelOnLoad])
    
    if (success)
        return (
            <Container maxWidth={false} component="main">
                <div className={classes.rootContent}>
                    <div className={classes.paper}>
                        <Success opcoes={opcoes}/>
                    </div>
                </div>
            </Container>
        )
    else
    return (
        <Container maxWidth={false} component="main">
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <Dialog
                        open={openedPainelList}
                        aria-labelledby="form-dialog-title"
                        PaperComponent={PaperComponent}
                        onBackdropClick={() => setOpenedPainelList(false)}
                        fullWidth>
                        <DialogTitle classes={{ root: classes.dialogTitle }}
                            id="draggable-dialog-title"
                            onClose={() => setOpenedPainelList(false)}>
                            {listVisualize.title}
                        </DialogTitle>

                        <DialogContent style={{ overflow: "hidden" }} >
                            <RegistrationUserListForm list={listVisualize} clickHandlerClose={() => setOpenedPainelList(false)} />
                        </DialogContent>

                    </Dialog>

                    {/* Form de edicao */}
                    <BoxSlide width='80%' isOpen={openedPainel} onClose={() => { 
                        setShedId(0); 
                        setMovementTypeId(0); 
                        setMovementTypeDescription(''); 
                        setOpenedPainel(false); 
                        }}>
                        <EditShedRegistrationForm 
                            shedId={shedId} 
                            movementTypeId={movementTypeId}
                            handleSetSuccess={setSuccess}
                            movementTypeDescription={movementTypeDescription}  
                            clickHandlerClose={() => { 
                                setShedId(0); 
                                setMovementTypeId(0); 
                                setMovementTypeDescription(''); 
                                setOpenedPainel(false); 
                                } } />
                    </BoxSlide>

                    <form onSubmit={handleSubmit(onSubmit)} >
                        <Grid container spacing={1}>
                            <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {tShed("searchResponsibleUser")}
                                </Typography>

                            </Grid>

                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI color="secondary" onClick={() => {  setShedId(0); setOpenedPainel(true); }} startIcon={<AddIcon />}>{tGeneral("add")}</ButtonUI>
                                <ButtonUI onClick={() => reset()} startIcon={<BackspaceOutlinedIcon />}>{tGeneral("clean")}</ButtonUI> 
                                <ButtonUI onClick={() => search()} color="primary" startIcon={<SearchIcon />}>{tGeneral("search")}</ButtonUI>                               
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>
                            <SelectShedMovementType
                                nameSelectShed={'shed'} 
                                nameSelectMovementType={'movementType'} 
                                control={control}
                                setValue={setValue} />  

                            <Grid item xs={1}>
                                <TextField 
                                    label={tShed("registration")} 
                                    name="registration" 
                                    control={control} 
                                    fullWidth
                                    inputRef={refFieldRegistration}/> 
                            </Grid>

                            <Grid item xs={2}>
                                <TextField 
                                    label={tShed("userName")} 
                                    name="userName" 
                                    control={control} 
                                    fullWidth/> 
                            </Grid>  

                            <Grid item xs={3}>
                                <SelectUser
                                    label={tShed("responsibleUser")} 
                                    name="responsibleUser"
                                    control={control} 
                                    fullWidth 
                                    includeSupplierUsers={false}
                                    />                                
                            </Grid>
                        </Grid>

                        {loading ? <LoadingUI /> :
                        <MuiThemeProvider theme={defaultGridTheme}>
                            <MUIDataTable
                                title=""
                                data={shedRegistrations}
                                columns={columns}                                    
                                options={{
                                    ...options,
                                    serverSide: true,
                                    pagination: true,
                                    sort: false,
                                    selectToolbarPlacement: "none",
                                    filter: false,
                                    search: false,
                                    download: false,
                                    print: false,
                                    viewColumns: false,
                                    selectableRows: 'none',
                                    page,
                                    count,
                                    rowsPerPage,
                                    
                                    onChangePage: (pageIndex) => { setPage(pageIndex) },
                                    onChangeRowsPerPage: (rowsPerPage) => { setPage(0); setRowsPerPage(rowsPerPage) },
                                }}
                            />
                        </MuiThemeProvider>
                    }
                    </form>
                </div>
            </div>
        </Container>
    )
}
export default ShedRegistration
